import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconMyProjects_1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 22 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5 13.875C21.5 14.8694 21.0689 15.5634 20.4851 15.9837C19.9396 16.3764 19.3075 16.5 18.875 16.5H2.625C1.63056 16.5 0.936647 16.0689 0.516349 15.4851C0.123586 14.9396 0 14.3075 0 13.875V1.75C0 0.783502 0.783502 0 1.75 0H7.74469C8.30074 0 8.82369 0.264253 9.15354 0.711902L9.55003 1.25H19.75C20.7165 1.25 21.5 2.0335 21.5 3V13.875ZM1.5 1.75C1.5 1.61193 1.61193 1.5 1.75 1.5H7.74469C7.82413 1.5 7.89884 1.53775 7.94596 1.6017L10.8465 5.5381C11.1763 5.98575 11.6993 6.25 12.2553 6.25H19.75C19.8885 6.25 20 6.36192 20 6.49952V13.875C20 14.3806 19.8061 14.6241 19.6086 14.7663C19.3729 14.9361 19.0675 15 18.875 15H2.625C2.11944 15 1.87585 14.8061 1.73365 14.6086C1.56391 14.3729 1.5 14.0675 1.5 13.875V1.75ZM20 4.76772V3C20 2.86193 19.8881 2.75 19.75 2.75H10.6553L12.054 4.6483C12.1012 4.71225 12.1759 4.75 12.2553 4.75H19.75C19.8349 4.75 19.9183 4.75604 20 4.76772Z",
  fill: "black"
}));
export { IconMyProjects_1 };